export default __webpack_public_path__ + "static/media/eyeOn-icon.ab9d2fd5.svg";